module.exports = __webpack_public_path__ + "static/media/five.a51767dd.jpg";